import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./Home.css";
import { FiMessageSquare, FiPhone, FiHeadphones, FiSend, FiX } from "react-icons/fi";
import {
  RiWhatsappLine,
  RiPhoneFindLine,
} from "react-icons/ri";
import { MdOutlinePointOfSale, MdOutlineRealEstateAgent } from "react-icons/md";
import ClientCarousel from "../../components/ClientCarousel";
import hex1 from "./assets/about11.jpg";
import hex2 from "./assets/about12.jpg";
import hex3 from "./assets/about13.jpg";
import hex4 from "./assets/title-logo1.png";
import icons1 from "./assets/icons1.png";
import icons2 from "./assets/icons2.png";
import icons3 from "./assets/icons3.png";
import icons5 from "./assets/icons4.png";
import FreightServices from "../../pages/Home/FreightServices.js";

import AOS from "aos";
import "aos/dist/aos.css";

import smsImg from "./assets/ser1.jpg";
import voiceImg from "./assets/Voice.jpg";
import ivrImg from "./assets/IVR.jpg";
import whatsappImg from "./assets/WhatsApp.jpg";
import missedImg from "./assets/Missed.jpg";
import stockImg from "./assets/Stockbroker.jpg";
import realestateImg from "./assets/Real.jpg";

const Home = () => {
  const whatsappLink =
    "https://wa.me/918800418585?text=Hello%20Shankarshan%20Team%2C%20I%20need%20help%20with%20your%20services.";

  const [showScrollTop, setShowScrollTop] = useState(false);
  const [showLeadPopup, setShowLeadPopup] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState("");
  const [statsValue, setStatsValue] = useState({
    clients: 0,
    years: 0,
    uptime: 0,
    products: 0,
    support: 0,
  });

  const contactApiUrl =
    process.env.REACT_APP_CONTACT_API_URL || "http://localhost:5000";

  useEffect(() => {
    const handleScroll = () => setShowScrollTop(window.scrollY > 300);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const duration = 1800;
    let animationFrame;
    const start = performance.now();
    const animate = (now) => {
      const progress = Math.min((now - start) / duration, 1);
      setStatsValue({
        clients: Math.round(1000 * progress),
        years: Math.round(20 * progress),
        uptime: 99.9 * progress,
        products: Math.round(9 * progress),
        support: Math.round(24 * progress),
      });
      if (progress < 1) animationFrame = requestAnimationFrame(animate);
    };
    animationFrame = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(animationFrame);
  }, []);

  useEffect(() => {
    const popupTimer = setTimeout(() => {
      setShowLeadPopup(true);
    }, 5000);

    return () => clearTimeout(popupTimer);
  }, []);

  useEffect(() => {
    if (!showLeadPopup) return undefined;

    document.body.classList.add("home-popup-open");
    return () => {
      document.body.classList.remove("home-popup-open");
    };
  }, [showLeadPopup]);

  const closeLeadPopup = () => {
    setShowLeadPopup(false);
    setSubmitError("");
  };

  const handlePopupSubmit = async (event) => {
    event.preventDefault();
    setSubmitError("");
    setIsSubmitted(false);

    const form = event.target;
    const formData = new FormData(form);
    const payload = {
      name: formData.get("name")?.toString().trim(),
      email: formData.get("email")?.toString().trim(),
      phone: formData.get("phone")?.toString().trim(),
      subject: formData.get("subject")?.toString().trim(),
      message: formData.get("message")?.toString().trim(),
    };

    try {
      setIsSubmitting(true);
      const response = await fetch(`${contactApiUrl}/api/contact`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error("Request failed");
      }

      setIsSubmitted(true);
      form.reset();
      setTimeout(() => {
        setIsSubmitted(false);
        setShowLeadPopup(false);
      }, 2000);
    } catch (error) {
      setSubmitError("Unable to send your inquiry right now. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });
  useEffect(() => {
    AOS.init({
      duration: 1200,
      once: true,
    });
  }, []);
  return (
    <div className="home-page" id="home">
      <section className="hero-section">
        <div className="hero-scanline" aria-hidden="true" />
        <div className="hero-gridoverlay" aria-hidden="true" />
        <div className="hero-particles" aria-hidden="true">
          <span />
          <span />
          <span />
          <span />
          <span />
          <span />
          <span />
          <span />
          <span />
          <span />
        </div>
        <div className="hero-bottomorb" aria-hidden="true" />
        <div className="container hero-container">
          <div className="hero-content">
            <h1 className="hero-title">
              Best bulk SMS, IVR & digital solution provider in india
              <br />
            </h1>
            <p className="hero-text">
              A professional <b>Bulk SMS Service Provider India</b> enables
              companies to send promotional messages, transactional SMS, OTP
              messages, alerts, and notifications right away. In today’s digital
              world, SMS advertising continues to be one of the only verbal
              exchange techniques because of its high open rate and fast
              delivery.
            </p>
            <div className="hero-ctas">
              <a
                href={whatsappLink}
                className="hero-btn-primary"
                target="_blank"
                rel="noopener noreferrer"
              >
                Let's Chat
              </a>
            </div>
            <div className="hero-trust">
              <span>✔ Trusted by 1000+ Businesses Across India</span>
              <span>✔ High-Speed Message Delivery (&lt;3 Sec OTP)</span>
              <span>
                ✔ Fully Compliant with DLT, TRAI Regulations &amp; SEBI
                Compliance
              </span>
            </div>
          </div>
        </div>
      </section>
      <section className="sectionz">
        <div className="leftz" data-aos="fade-right">
          <img src={hex1} className="img1z" alt="cyber security" />
          <img src={hex2} className="img2z" alt="cyber protection" />
          <img src={hex3} className="img3z" alt="data security" />
          <div className="badgez"><img src={hex4} alt="data security" /></div>
        </div>

        <div className="rightz" data-aos="fade-left">
          <div className="aboutz" data-aos="fade-up">
            About Shankarshan Technologies
          </div>
          <h1 data-aos="zoom-in">
            <span>About Shankarshan Technologies</span>
          </h1>
          <p className="descz" data-aos="fade-up">
            <b>Shankarshan Technologies</b> is a leading IT and conversation
            solutions enterprise that provides Bulk SMS Service Provider India,
           <b> Interactive Voice Response</b>, and digital communication offerings to
            corporations across India. The employer facilitates groups to
            enhance client conversations through superior messaging and calling
            answers.
          </p>

          <div className="featuresz" data-aos="fade-up">
            <ul className="listz">
              <p className="descz" data-aos="fade-up">
                Why Choose Shankarshan Technologies
              </p>
              <li>
                <span className="check-icon">→</span>
                Trusted service provider
              </li>
              <li>
                <span className="check-icon">→</span>
                24/7 customer support
              </li>
              <li>
                <span className="check-icon">→</span>
                Affordable pricing plans
              </li>
            </ul>

            <Link to="/about" className="btnz">
              More About →
            </Link>
          </div>
        </div>
      </section>
      <FreightServices />

      <section className="services-section" id="services">
        <div className="container">
          <div className="services-header">
            <p className="services-label">Our Services</p>
            <h2 className="services-title">
              Services Offered by{" "}
              <span className="services-highlight">
                Shankarshan Technologies
              </span>
            </h2>
            <p className="services-description">
              Shankarshan Technologies offers Bulk SMS, IVR, Voice Calls, 
              WhatsApp API, Missed Call Services, Stockbroker Software, and Real
              Estate Tracking solutions to help agencies automate communication
              and enhance client engagement effectively.
            </p>
          </div>

          <div className="services-grid">
            {[
              {
                num: "01",
                icon: <FiMessageSquare />,
                title: "SMS Solutions",
                href: "services/sms",
                image: smsImg,
                desc: "SMS Solutions help organizations speak with customers right away, the use of Transactional SMS, Promotional SMS, and OTP SMS on one platform. Our SMS Solutions are fully DLT compliant and offer excessive-velocity shipping throughout all Indian operators with real-time reports and a developer-friendly API.",
              },
              {
                num: "02",
                icon: <FiPhone />,
                title: "Voice Solutions",
                href: "services/voice",
                image: voiceImg,

                desc: "Voice Solutions assists businesses in managing inbound and outbound calls professionally through the use of automation and cloud telephony. Our superior Voice Solutions include IVR, Cloud IVR, Cloud Call Centre, and Missed Call Service to help companies automate verbal exchange and enhance client engagement.",
              },
              {
                num: "03",
                icon: <FiHeadphones />,
                title: "IVR Solutions",
                href: "services/ivr",
                image: ivrImg,
                desc: "IVR Solutions allow agencies to automate name handling using an Interactive Voice Response machine. With expert IVR Solutions, organizations can greet callers with a welcome message and offer menu alternatives that include Press 1 for Sales, Press 2 for Support, and Press three for Billing.",
              },
              {
                num: "04",
                icon: <RiWhatsappLine />,
                title: "WhatsApp API & chatbot",
                href: "services/WhatsAppApi",
                image: whatsappImg,

                desc: "WhatsApp API & Chatbot Solutions help companies speak with customers on WhatsApp through the usage of the authentic WhatsApp Business API. With WhatsApp API & Chatbot Solutions, agencies can ship messages, pics, PDFs, movies, and interactive messages directly to clients.",
              },
              {
                num: "05",
                icon: <RiPhoneFindLine />,
                title: "Missed Call Service",
                href: "services/missed-call",
                image: missedImg,

                desc: "Missed Call Service is one of the most affordable lead technology in India. With Missed Call Service, companies can assign a variety of ways where clients supply an ignored name and the commercial enterprise gets the lead immediately via SMS, email, or API. This Service is best for lead and customer feedback collection.",
              },
              {
                num: "08",
                icon: <MdOutlinePointOfSale />,
                title: "Stockbroker Software",
                href: "services/stockbroker",
                image: stockImg,

                desc: "Our Stockbroker Software provides a whole verbal exchange gadget for stockbroker companies. Stockbroker Software includes TradeInfo, DropCopy, TradeFTP, Trade Notification, and the Sampark Call & Trade IVR device. With our Software, stockbroker companies can automate verbal exchange and enhance client engagement.",
              },
              // {
              //   num: "09",
              //   icon: <MdOutlineRealEstateAgent />,
              //   title: "Real Estate Tracking",
              //   href: "services/real-estate",
              //   image: realestateImg,

              //   desc: "Real Estate Tracking Solutions assist real estate companies to tune subject dealers, manage web page visits, and capture property enquiries from one dashboard. With Real Estate Tracking Solutions, businesses can record inbound calls, outbound calls, GPS attendance, and placement visit reviews.",
              // },
            ].map((s) => (
              <article className="service-card" key={s.num}>
                <div className="card-top">
                  <div className="card-icon">{s.icon}</div>
                  <h3 className="service-title">{s.title}</h3>
                </div>

                <div className="card-images">
                  <img src={s.image} alt={s.title} />
                </div>

                <p className="service-desc">{s.desc}</p>

                <div className="card-divider"></div>

                <a href={s.href} className="service-btn">
                  <span className="arrowf">→</span> View Details
                </a>
              </article>
            ))}
          </div>
        </div>
      </section>
      <section className="stats-bar">
        <div className="container stats-grid">
          <div className="stat-item">
            <img src={icons1} alt="" />
            <div className="stat-number">{statsValue.clients}+</div>
            <div className="stat-label">Happy Clients</div>
          </div>
          <div className="stat-item">
            <img src={icons2} alt="" />

            <div className="stat-number">{statsValue.uptime.toFixed(1)}%</div>
            <div className="stat-label">Uptime SLA</div>
          </div>
          <div className="stat-item">
            <img src={icons3} alt="" />

            <div className="stat-number">{statsValue.products}</div>
            <div className="stat-label">Enterprise Products</div>
          </div>
          <div className="stat-item">
            <img src={icons5} alt="" />

            <div className="stat-number">{statsValue.support}/7</div>
            <div className="stat-label">Support Available</div>
          </div>
        </div>
      </section>
      <ClientCarousel />

      {showLeadPopup && (
        <div className="home-popup-overlay" onClick={closeLeadPopup}>
          <div
            className="home-popup-card"
            role="dialog"
            aria-modal="true"
            aria-labelledby="home-popup-title"
            onClick={(event) => event.stopPropagation()}
          >
            <button
              type="button"
              className="home-popup-close"
              onClick={closeLeadPopup}
              aria-label="Close form"
            >
              <FiX />
            </button>

            <p className="home-popup-label">Quick Inquiry</p>
            <h3 id="home-popup-title">Talk to our team in under 1 minute</h3>
            <p className="home-popup-subtitle">
              Share your details and we will call you back with the best plan for SMS, IVR,
              WhatsApp, or Voice solutions.
            </p>

            <form className="home-popup-form" onSubmit={handlePopupSubmit}>
              <div className="home-popup-row">
                <input name="name" type="text" placeholder="Full Name" required />
              </div>
              <div className="home-popup-row home-popup-row-split">
                <input name="email" type="email" placeholder="Email Address" required />
                <input name="phone" type="tel" placeholder="Phone Number" required />
              </div>
              <div className="home-popup-row">
                <input name="subject" type="text" placeholder="Subject" required />
              </div>
              <div className="home-popup-row">
                <textarea
                  name="message"
                  rows="4"
                  placeholder="Tell us about your requirement"
                  required
                />
              </div>

              <button type="submit" className="home-popup-submit" disabled={isSubmitting}>
                <FiSend />
                {isSubmitting ? "Sending..." : "Submit Inquiry"}
              </button>

              {isSubmitted && (
                <p className="home-popup-feedback success">
                  Thank you. Our team will contact you soon.
                </p>
              )}
              {submitError && <p className="home-popup-feedback error">{submitError}</p>}
            </form>
          </div>
        </div>
      )}

      {showScrollTop && (
        <button
          className="scroll-top-btn"
          onClick={scrollToTop}
          aria-label="Scroll to top"
        >
          ↑
        </button>
      )}
    </div>
  );
};

export default Home;
